import { Check, Undo2 } from 'lucide-react';

import { DANGER_RED } from '../../primitives';

import { OUTLINE_ACTION_STYLE } from './tree-replacement-styles';
import { useRowActionStyle } from './use-row-action-style';
import { useUpdateTreeReplacement } from './use-tree-replacements';

export function TreeReplacementPickupToggle({
  workshopId,
  treeReplacementId,
  customerName,
  pickedUp,
}: {
  workshopId: string;
  treeReplacementId: string;
  customerName: string;
  pickedUp: boolean;
}) {
  const toggle = useUpdateTreeReplacement(workshopId);
  const actionStyle = useRowActionStyle();
  const Icon = pickedUp ? Undo2 : Check;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
      <button
        type="button"
        className="nb-btn nb-btn-ghost"
        disabled={toggle.isPending}
        aria-label={`${pickedUp ? 'Undo pickup for' : 'Mark picked up for'} ${customerName}`}
        onClick={() => toggle.mutate({ id: treeReplacementId, patch: { pickedUp: !pickedUp } })}
        style={{ ...actionStyle, ...OUTLINE_ACTION_STYLE }}
      >
        <Icon size={13} strokeWidth={2.5} aria-hidden />
        {pickedUp ? 'Undo' : 'Mark picked up'}
      </button>
      {toggle.error && (
        <span role="alert" style={{ fontSize: 10.5, color: DANGER_RED, maxWidth: 220 }}>
          {toggle.error.message}
        </span>
      )}
    </div>
  );
}
